import React from 'react';
import classNames from 'classnames';
import { Heading } from '../Heading/Heading';
import { Button } from '../Button/Button';
import { Icon, IconName } from '../Icon/Icon';
/**
 * Bronson [ItemTeaser](https://bronson.vwfs.io/default/components/detail/bronson-item-teaser.html) component.
 */
export function ItemTeaser({ alternative, block, blockSmallScreen, children, className, headingLevel, icon, iconClassName, inline, inlineSmallScreen, linkButton, linkIcon = IconName.FORWARD, linkLabel, linkProps, row, semanticContainer = 'div', small, title, testId, ...otherProps }) {
    const articleClassNameList = classNames('c-item-teaser', {
        // Convenience props from Bronson variants.
        'c-item-teaser--small': small,
        'c-item-teaser--inline': inline,
        'c-item-teaser--alternative': alternative,
        'c-item-teaser--row': row,
        'c-item-teaser--block': block,
        'c-item-teaser--inline@small-screen': inlineSmallScreen,
        'c-item-teaser--block@small-screen': blockSmallScreen,
    }, className).trim();
    const CustomElement = `${semanticContainer}`;
    const iClassNameList = classNames('c-item-teaser__icon', iconClassName).trim();
    function renderIfItemTeaserLinkLabel() {
        if (linkLabel) {
            const linkAttrs = linkButton ? {} : { link: true, simple: true, small: true };
            return (React.createElement("div", { className: "c-item-teaser__link" },
                React.createElement(Button, { icon: linkIcon === null ? undefined : linkIcon, ...linkAttrs, ...linkProps }, linkLabel)));
        }
        return null;
    }
    function renderIfIcon() {
        if (icon) {
            return React.createElement(Icon, { className: iClassNameList, name: icon });
        }
        return null;
    }
    /**
     * If {@link headingLevel} is provided the title is rendered as the corresponding Heading element.
     * If no {@link headingLevel} is provided, the title is rendered as a `<span>`.
     * @returns {React.JSX.Element | null}
     */
    function renderTitle() {
        if (headingLevel) {
            return (React.createElement(Heading, { level: headingLevel, className: "c-item-teaser__title" }, title));
        }
        else {
            return React.createElement("span", { className: "c-item-teaser__title" }, title);
        }
    }
    function renderIfText() {
        if (children) {
            return React.createElement("div", { className: "c-item-teaser__text" }, children);
        }
        return null;
    }
    return (React.createElement(CustomElement, { ...otherProps, "data-testid": testId, className: articleClassNameList },
        renderIfIcon(),
        React.createElement("div", { className: "c-item-teaser__body" },
            renderTitle(),
            renderIfText(),
            renderIfItemTeaserLinkLabel())));
}
